<template>
    <rkm-area
        no-margin-top
        title="Local de atendimento"
        type="fieldset"
    >
        <template v-slot:trailing>
            <rkm-button
                @click="$refs.Modal.create()"
                color="primary"
                small
            >
                <rkm-icon icon="plus" />
            </rkm-button>
        </template>

        <List :data="data" />

        <Modal
            :data="data"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: {
        List,
        Modal,
    },
    props: {
        data: {required: true, type: Object},
    },
}
</script>